"use client";

import { useEffect } from "react";

export function ReCaptchaBadgeController() {
    useEffect(() => {
        // Show reCAPTCHA badge on auth pages only
        document.body.classList.add("show-recaptcha-badge");
        return () => {
            document.body.classList.remove("show-recaptcha-badge");
        };
    }, []);

    return null; // This component doesn't render anything
}
